module.exports = __webpack_public_path__ + "img/pay-local-banner.95c5883a.png";